export default __webpack_public_path__ + "static/media/blur.05b46198.svg";